import { render, staticRenderFns } from "./RulesContent.vue?vue&type=template&id=b09fe204&scoped=true"
import script from "./RulesContent.vue?vue&type=script&lang=js"
export * from "./RulesContent.vue?vue&type=script&lang=js"
import style0 from "./RulesContent.vue?vue&type=style&index=0&id=b09fe204&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09fe204",
  null
  
)

export default component.exports